"use client";

import { Button, HStack, Text } from "@chakra-ui/react";
import GenericIcon from "@/shared/ui/actions/GenericIcon";
import type { StudioQuickAction } from "./useStudioScreen";

type StudioQuickActionButtonProps = {
  action: StudioQuickAction;
  onActionClick: (action: StudioQuickAction["key"]) => Promise<void>;
};

export default function StudioQuickActionButton({
  action,
  onActionClick,
}: StudioQuickActionButtonProps) {
  return (
    <Button
      variant="outline"
      onClick={() => {
        void onActionClick(action.key);
      }}
      title={action.humanReadable}
      aria-label={action.humanReadable}
      borderColor="moveon.surface.interactiveBorder"
      borderRadius="md"
      color="moveon.surface.fg"
      px={{ base: "2.5", md: "3" }}
      py={{ base: "2", md: "1" }}
      minW="auto"
      h="auto"
      disabled={action.disabled}
      _hover={{
        bg: "moveon.surface.elevatedBg",
        borderColor: "moveon.selection.hoverBorder",
      }}
    >
      <HStack gap="2">
        <GenericIcon
          icon={action.icon}
          humanReadable={action.humanReadable}
          visuallyInactive={action.disabled}
        />
        <Text
          display={{ base: "none", md: "inline" }}
          fontSize="sm"
          fontWeight="medium"
          color={action.disabled ? "moveon.text.muted" : undefined}
        >
          {action.label}
        </Text>
      </HStack>
    </Button>
  );
}
